import { h } from 'preact'
import { IMatchesByDay } from '../../lib/model'
import styles from './MatchesSection.module.css'
import { MatchResult } from '../MatchResult/MatchResult'
import { MatchStatus } from '../MatchStatus/MatchStatus'
import { MatchTeams } from '../MatchTeams/MatchTeams'
import { useEffect, useState } from 'preact/hooks'
import {
  findNearestGameIndex,
  findNearestTournamentDay,
  formatMatchDate,
  isNearestTournamentDay,
  sortMatches,
  statusLabel,
} from './match-section-utils'

interface Props {
  matches: IMatchesByDay
  openInParent: Boolean
}

export function MatchesSection(props: Props) {
  const [todayElement, setTodayElement] = useState<HTMLTimeElement | null>(null)
  const [coreScrollElement, setCoreScrollElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (todayElement) {
      coreScrollElement?.scroll(todayElement.offsetLeft, 0)
    }
  }, [coreScrollElement, todayElement])

  return (
    <div class={styles['dh-fotball-banner__matchesSection']}>
      <div
        ref={setCoreScrollElement}
        class={styles['dh-fotball-banner__scrollItemsWrapper']}
        id={'scroll'}
      >
        {collectElementsList(props.matches, setTodayElement, props.openInParent)}
      </div>
    </div>
  )
}

export function collectElementsList(
  matches: IMatchesByDay,
  setTodayElement,
  openInParent: Boolean
) {
  const nearestTournamentDay = findNearestTournamentDay(matches)

  const elementsList = []
  Object.keys(matches).forEach((matchDay) => {
    const isNearestDay = isNearestTournamentDay(matchDay, nearestTournamentDay)
    const timeElement = (
      <div class={`${styles['dh-fotball-banner__matches-date']}`}>
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          style="width:1.5em;height:1.5em"
          focusable="false"
          aria-hidden="true"
        >
          <path
            fill="#f5fdfe"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 1h2v2h8V1h2v2h4v19H2V3h4V1zM4 20V7h16v13H4zM8 9H6v2h2V9zm2 0h2v2h-2V9zm-2 4H6v2h2v-2z"
          />
        </svg>

        <time dateTime={matchDay}>{formatMatchDate(matchDay)}</time>
      </div>
    )
    elementsList.push(timeElement)

    const sorted = sortMatches(matches[matchDay])
    const nearestGameIndex = isNearestDay ? findNearestGameIndex(sorted) : -1

    sorted.forEach((matchData, index) => {
      const status = statusLabel(matchData.matchStatusId)
      const matchElement =
        nearestGameIndex === index ? (
          <div
            ref={setTodayElement}
            class={
              status === 'Pågår'
                ? styles['dh-fotball-banner__match-details-ongoing']
                : styles['dh-fotball-banner__match-details']
            }
          >
            <MatchStatus matchData={matchData} statusLabel={status} />
            <MatchResult result={matchData.result} statusLabel={status} />
            <MatchTeams matchData={matchData} openInParent={openInParent} />
          </div>
        ) : (
          <div
            class={
              status === 'Pågår'
                ? styles['dh-fotball-banner__match-details-ongoing']
                : styles['dh-fotball-banner__match-details']
            }
          >
            <MatchStatus matchData={matchData} statusLabel={status} />
            <MatchResult result={matchData.result} statusLabel={status} />
            <MatchTeams matchData={matchData} openInParent={openInParent} />
          </div>
        )
      elementsList.push(matchElement)
    })
  })

  return elementsList
}
